import dayjs from 'dayjs';
import { ExportToCsv } from 'export-to-csv-fix-source-map';
import { useCallback } from 'react';
import { useAppSelector } from '../../../app/hooks';
import { useBlock } from '../../../services/entities/hooks/useBlock';
import { UnitsEnum } from '../../../services/entities/impl/blfApi/apiConstants';
import { useGetScanByIdQuery } from '../../../services/entities/impl/blfApi/endpoints/scans';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import useScanData from '../../scanDataApi/hooks/useScanData';
import { selectCurrBlockID, selectCurrScanID } from '../../select/selectSlice';
import { useUnits } from '../../settings/hooks/useUnits';

export const useExportGrapeDiameterDistributionChart = () => {
  const {
    distributionInterval: { isLoading, data },
  } = useScanData();

  const { t } = useTranslation();

  const units = useUnits();

  const currBlockID = useAppSelector(selectCurrBlockID);
  const currScanID = useAppSelector(selectCurrScanID);

  const { block: currBlock } = useBlock(currBlockID);
  const { currentData: currScan } = useGetScanByIdQuery(currScanID);

  const exportCSV = useCallback(() => {
    if (isLoading || !data) return;

    const columns = [
      `${t('Average Diameter')} (${
        units === UnitsEnum.imperial ? 'in' : 'mm'
      })`,
      t('Frequency'),
    ];

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: true,
      filename: `Block-${currBlock?.name}-${dayjs(currScan?.scanDate).format(
        'YYYY-MM-DD'
      )}-Average-Diameter-Distribution`,
      headers: columns,
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(data);
  }, [isLoading, data, t, units, currBlock?.name, currScan?.scanDate]);

  return { exportCSV };
};
